import { render } from "./HRMSetting.vue?vue&type=template&id=2ae7d097&scoped=true"
import script from "./HRMSetting.vue?vue&type=script&lang=js"
export * from "./HRMSetting.vue?vue&type=script&lang=js"

import "./HRMSetting.vue?vue&type=style&index=0&id=2ae7d097&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae7d097"]])

export default __exports__